import type { Permission } from './roles';

export const API_KEY_SCOPES = ['members:read', 'payments:read', 'visits:read', 'classes:read'] as const;
export type ApiKeyScope = (typeof API_KEY_SCOPES)[number];

/** What each scope lets a key do: one read permission, never a role. */
export const API_KEY_SCOPE_PERMISSIONS: Readonly<Record<ApiKeyScope, Permission>> = {
  'members:read': 'members.read',
  'payments:read': 'payments.read',
  'visits:read': 'access.read',
  'classes:read': 'classes.read',
};

export const API_KEY_STATUSES = ['ACTIVE', 'EXPIRED', 'REVOKED'] as const;
export type ApiKeyStatus = (typeof API_KEY_STATUSES)[number];

export const WEBHOOK_EVENTS = ['member.created', 'membership.activated', 'membership.expired', 'payment.succeeded', 'payment.refunded', 'visit.recorded'] as const;
export type WebhookEvent = (typeof WEBHOOK_EVENTS)[number];

/** A test a gym sends itself from the admin: delivered and signed like any event, never subscribed to. */
export const WEBHOOK_TEST_EVENT = 'ping';
export const WEBHOOK_DELIVERY_EVENTS = [...WEBHOOK_EVENTS, WEBHOOK_TEST_EVENT] as const;
export type WebhookDeliveryEvent = (typeof WEBHOOK_DELIVERY_EVENTS)[number];

export const WEBHOOK_DELIVERY_STATUSES = ['PENDING', 'SUCCEEDED', 'FAILED', 'SKIPPED'] as const;
export type WebhookDeliveryStatus = (typeof WEBHOOK_DELIVERY_STATUSES)[number];

/** Why an attempt got no answer from the receiver; an answer that is not 2xx is recorded by its status code instead. */
export const WEBHOOK_DELIVERY_ERRORS = ['TIMEOUT', 'CONNECTION_FAILED', 'TLS_FAILED', 'PRIVATE_ADDRESS', 'UNRESOLVABLE', 'INVALID_URL', 'ENDPOINT_DISABLED', 'SECRET_UNREADABLE'] as const;
export type WebhookDeliveryError = (typeof WEBHOOK_DELIVERY_ERRORS)[number];
